import { getIconProps, type IconProps } from '#types'

/**
 * Calendar icon — date picker and scheduling.
 *
 * Stroke-based outline with two binding tabs at the top and a horizontal
 * header divider. Used for date selection, scheduling, and calendar-related
 * actions.
 *
 * @example
 * ```tsx
 * <button>
 *   <CalendarIcon className="h-4 w-4" /> Select date
 * </button>
 * ```
 */
export function CalendarIcon({ strokeWidth = 1.5, ...props }: IconProps) {
  return (
    <svg {...getIconProps(props)} viewBox="0 0 24 24">
      <path
        d="M9 2.75012V5.76455"
        stroke="currentColor"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15 2.75012V5.76455"
        stroke="currentColor"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.9361 10.6919C20.9806 11.3778 21 12.1295 21 12.9527C21 20.3998 19.4115 21.996 12 21.996C4.5885 21.996 3 20.3998 3 12.9527C3 12.1295 3.01941 11.3778 3.06395 10.6919M20.9361 10.6919C20.5777 5.1722 18.5923 3.90942 12 3.90942C5.40774 3.90942 3.42232 5.1722 3.06395 10.6919M20.9361 10.6919H3.06395"
        stroke="currentColor"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export const Calendar = CalendarIcon
